import { AgentZoneFilterPipe } from './agent/agent-table/agent-zone-filter.pipe';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LeftMenuComponent } from './left-menu/left-menu.component';
import { LayoutModule } from '@angular/cdk/layout';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatChipsModule } from '@angular/material/chips'


//  anguar material
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { LoginComponent } from './login/login.component';
import { ShellComponent } from './shell/shell.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule, MatFormField } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonToggleModule, MatProgressBarModule } from '@angular/material';
//  angular material

import { AgentRegisterComponent } from './agent/agent-register/agent-register.component';
import { ZoneRegisterComponent } from './master/zone-register/zone-register.component';
import { MasterOverviewComponent } from './master/master-overview/master-overview.component';
import { BoothTypeRegisterComponent } from './master/booth-type-register/booth-type-register.component';
import { ConstituencyRegisterComponent } from './master/constituency-register/constituency-register.component';
import { WardRegisterComponent } from './master/ward-register/ward-register.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { ZoneTableComponent } from './zone/zone-table/zone-table.component';
import { BoothTypeTableComponent } from './booth/booth-type-table/booth-type-table.component';
import { WardTableComponent } from './ward/ward-table/ward-table.component';
import { ConstituencyTableComponent } from './constituency/constituency-table/constituency-table.component';
import { AgentTableComponent } from './agent/agent-table/agent-table.component';
import { ProductGroupTableComponent } from './product/product-group-table/product-group-table.component';
import { ProductRegisterComponent } from './product/product-register/product-register.component';
import { ProductGroupRegisterComponent } from './product/product-group-register/product-group-register.component';
import { VehicleTransportTableComponent } from './vehicle-transport/vehicle-transport-table/vehicle-transport-table.component';
import { ProductTableComponent } from './product/product-table/product-table.component';
import { ProductUnitTableComponent } from './product/product-unit-table/product-unit-table.component';
import { ProductUnitRegisterComponent } from './product/product-unit-register/product-unit-register.component';
import { BoothTableComponent } from './booth/booth-table/booth-table.component';
import { BoothRegisterComponent } from './booth/booth-register/booth-register.component';
import { MatInputModule, MatNativeDateModule, MatHorizontalStepper, MatStep, MatStepperModule, MatAutocompleteModule, MatTab, MatTabGroup, MatTabsModule } from '@angular/material';
import { MaserPageHeaderComponent } from './maser-page-header/maser-page-header.component';
import { VehicleTransportRegisterComponent } from './vehicle-transport/vehicle-transport-register/vehicle-transport-register.component';
import { RelationTypeRegisterComponent } from './relation-type/relation-type-register/relation-type-register.component';
import { RelationTypeTableComponent } from './relation-type/relation-type-table/relation-type-table.component';
import { TalukTableComponent } from './taluk/taluk-table/taluk-table.component';
import { TalukRegisterComponent } from './taluk/taluk-register/taluk-register.component';
import { EmployeeTableComponent } from './employee/employee-table/employee-table.component';
import { EmployeeRegisterComponent } from './employee/employee-register/employee-register.component';
import { UnionOfficeRegisterComponent } from './union-office/union-office-register/union-office-register.component';
import { UnionOfficeTableComponent } from './union-office/union-office-table/union-office-table.component';
import { LocationCategoryTableComponent } from './location-category/location-category-table/location-category-table.component';
import { LocationCategoryRegisterComponent } from './location-category/location-category-register/location-category-register.component';
import { IcustomerTableComponent } from './icustomer/icustomer-table/icustomer-table.component';
import { IcustomerRegisterComponent } from './icustomer/icustomer-register/icustomer-register.component';
import { VehicleTypeTableComponent } from './vehicle-type/vehicle-type-table/vehicle-type-table.component';
import { VehicleTypeRegisterComponent } from './vehicle-type/vehicle-type-register/vehicle-type-register.component';
import { VehicleRegisterComponent } from './vehicle/vehicle-register/vehicle-register.component';
import { VehicleTableComponent } from './vehicle/vehicle-table/vehicle-table.component';
import { RouteTableComponent } from './route/route-table/route-table.component';
import { RouteRegisterComponent } from './route/route-register/route-register.component';
import { ProductPriceEditShellComponent } from './product-price/product-price-edit-shell/product-price-edit-shell.component';
import { BusinessTypeWiseComponent } from './product-price/business-type-wise/business-type-wise.component';
import { BusinessTypeWiseProductCommissionEditComponent } from './business-type-wise-product-commission-edit/business-type-wise-product-commission-edit.component';
import { MatDialogModule } from '@angular/material/dialog';
import { DiscountProductPriceEditComponent } from './discount-product/discount-product-price-edit/discount-product-price-edit.component';
import { BusinessWiseDiscountPriceEditDiaglogComponent } from './discount-product/business-wise-discount-price-edit-diaglog/business-wise-discount-price-edit-diaglog.component';
import { BusinessTypeWiseProductDiscountComponent } from './discount-product/business-type-wise-product-discount/business-type-wise-product-discount.component';
import { BusinessTypeWiseProductDiscountEditDialogComponent } from './discount-product/business-type-wise-product-discount-edit-dialog/business-type-wise-product-discount-edit-dialog.component';
import { RouteBusinessMapComponent } from './route/route-business-map/route-business-map.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatDividerModule } from '@angular/material/divider';
import { AgentOrderComponent } from './agent/agent-order/agent-order.component';
import { IcustomerTypeWiseDiscountProductPriceComponent } from './icustomer-product/icustomer-type-wise-discount-product-price/icustomer-type-wise-discount-product-price.component';
import { IcustomerTypeWiseDiscountProductPriceEditDialogBoxComponent } from './icustomer-product/icustomer-type-wise-discount-product-price-edit-dialog-box/icustomer-type-wise-discount-product-price-edit-dialog-box.component';
import { ProductTraceComponent } from './trace/product-trace/product-trace.component';
import { BusinessTypeWiseProductCommissionTraceLogComponent } from './trace/business-type-wise-product-commission-trace-log/business-type-wise-product-commission-trace-log.component';
import { BusinessTypeWiseProductDiscountTraceLogComponent } from './trace/business-type-wise-product-discount-trace-log/business-type-wise-product-discount-trace-log.component';
import { BusinessWiseProductDiscountTraceLogComponent } from './trace/business-wise-product-discount-trace-log/business-wise-product-discount-trace-log.component';
import { IcustomerTypeWiseProductDiscountTraceLogComponent } from './trace/icustomer-type-wise-product-discount-trace-log/icustomer-type-wise-product-discount-trace-log.component';
import { BoothRegisterPopupComponent } from './booth/booth-register-popup/booth-register-popup.component';
import { AgentOrderPipe, ProductPricePipe } from './agent/agent-order/agent-order.pipe';
import { IndentDashboardComponent } from './indent/indent-dashboard/indent-dashboard.component';
import { RouteIndentDetailsComponent } from './indent/route-indent-details/route-indent-details.component';
import { ProductSessionAvailableEditComponent } from './product/product-session-available-edit/product-session-available-edit.component';
import { TimeExpirePipe } from './indent/time-expire.pipe';
import { IcustomerOrderRegisterComponent } from './icustomer/icustomer-order-register/icustomer-order-register.component';
import { IcustomerOrderHistoryComponent } from './icustomer/icustomer-order-history/icustomer-order-history.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProductMasterComponent } from './master/product-master/product-master.component';
import { AgentOrderHistoryComponent } from './agent/agent-order-history/agent-order-history.component';
import { RouteVehicleMapTableComponent } from './route/route-vehicle-map-table/route-vehicle-map-table.component';
import { BusinessWiseBillComponent } from './report/business-wise-bill/business-wise-bill.component';
import { RouteGatepassComponent } from './report/route-gatepass/route-gatepass.component';
import { RouteWiseBillComponent } from './report/route-wise-bill/route-wise-bill.component';
import { AlertComponent } from './alert/alert.component';
import { SidemenuComponent } from './sidemenu/sidemenu.component';
import { AgentMonthlyReportComponent } from './agent/agent-monthly-report/agent-monthly-report.component';
import { CorporationZoneTableComponent } from './corporation_zone/corporation-zone-table/corporation-zone-table.component';
import { CorporationZoneRegisterComponent } from './corporation_zone/corporation-zone-register/corporation-zone-register.component';
import { AgentImagePopupComponent } from './agent/agent-image-popup/agent-image-popup.component';
import { DistrictTableComponent } from './district/district-table/district-table.component';
import { DistrictRegisterComponent } from './district/district-register/district-register.component';
import { AgentConfirmOrderComponent } from './agent/agent-confirm-order/agent-confirm-order.component';
import { BlockTableComponent } from './block/block-table/block-table.component';
import { BlockRegisterComponent } from './block/block-register/block-register.component';
import { IcustomerConfirmOrderComponent } from './icustomer/icustomer-confirm-order/icustomer-confirm-order.component';
import { IcustomerLimitErrorComponent } from './icustomer/icustomer-limit-error/icustomer-limit-error.component';
import { AddToWalletComponent } from './transaction/add-to-wallet/add-to-wallet.component';
import { ChequeApprovalComponent } from './transaction/cheque-approval/cheque-approval.component';
import { ChequeClearPopupComponent } from './transaction/cheque-clear-popup/cheque-clear-popup.component';
import { AgentTransactionComponent } from './transaction/agent-transaction/agent-transaction.component';
import { IcustomerTransactionComponent } from './transaction/icustomer-transaction/icustomer-transaction.component';
import { AgentOrderEditComponent } from './agent/agent-order-edit/agent-order-edit.component';
import { BoothChangeForOrderComponent } from './icustomer/booth-change-for-order/booth-change-for-order.component';
import { AgmCoreModule } from '@agm/core';
import { IndivioulBoothSelectionComponent } from './icustomer/indivioul-booth-selection/indivioul-booth-selection.component';
import { RouteTraceAdjustComponent } from './indent/route-trace-adjust/route-trace-adjust.component';
import { NotClosedRouteListComponent } from './indent/not-closed-route-list/not-closed-route-list.component';
import { ZoneWiseCountComponent } from './agent/zone-wise-count/zone-wise-count.component';
import { CounterReportPerDayComponent } from './report/counter-report-per-day/counter-report-per-day.component';
import { OldIndentComponent } from './indent/old-indent/old-indent.component';
import { TotalSalePerDayComponent } from './report/total-sale-per-day/total-sale-per-day.component';
import { TotalSalePerMonthComponent } from './report/total-sale-per-month/total-sale-per-month.component';
import { RouteWiseSaleAbstraceComponent } from './report/route-wise-sale-abstrace/route-wise-sale-abstrace.component';
import { UniqueRouteWiseReportComponent } from './report/unique-route-wise-report/unique-route-wise-report.component';
import { PipesModule } from './global-pipe/pipes.module';
import { RouteVehicleEditComponent } from './route/route-vehicle-edit/route-vehicle-edit.component';
import { MilkAcknowlegdementReportPerSessionComponent } from './report/milk-acknowlegdement-report-per-session/milk-acknowlegdement-report-per-session.component';
import { AllZoneReportPerSessionComponent } from './report/all-zone-report-per-session/all-zone-report-per-session.component';
import { DailySaleZoneWiseComponent } from './report/daily-sale-zone-wise/daily-sale-zone-wise.component';
import { TempComponent } from './temp/temp.component';
import { RouteWiseSaleStatementComponent } from './report/route-wise-sale-statement/route-wise-sale-statement.component';
import { ZoneWiseAbstractComponent } from './report/zone-wise-abstract/zone-wise-abstract.component';
import { BusinessTypeWiseSummaryComponent } from './report/business-type-wise-summary/business-type-wise-summary.component';
import { PdfPreviewComponent } from './pdf-preview/pdf-preview.component';
import { UnionWiseSummaryComponent } from './report/union-wise-summary/union-wise-summary.component';
import { ZoneWiseRouteAbstractComponent } from './report/zone-wise-route-abstract/zone-wise-route-abstract.component';
import { AgentMonthlyCommissionComponent } from './report/monthly-report/agent-monthly-commission/agent-monthly-commission.component';
import { DiffrentTypeOfReportComponent } from './report/diffrent-type-of-report/diffrent-type-of-report.component';
import { RouteTimeChangeComponent } from './route/route-time-change/route-time-change.component';
import { AmazingTimePickerModule } from 'amazing-time-picker';
import { FinanceReportComponent } from './report/finance-report/finance-report.component';
import { TotalMilkSaleComponent } from './report/total-milk-sale/total-milk-sale.component';
import { InstitionBillComponent } from './report/instition-bill/instition-bill.component';
import { TrayCountComponent } from './report/tray-count/tray-count.component';
import { LeakageAllowanceComponent } from './report/leakage-allowance/leakage-allowance.component';
import { SimpleComparisionReportComponent } from './report/simple-comparision-report/simple-comparision-report.component';
import { AdvanacedComparisonReportComponent } from './report/advanaced-comparison-report/advanaced-comparison-report.component';
import { GeneralReportForRouteComponent } from './report/general-report-for-route/general-report-for-route.component';
import { IcustomerBoothChangeComponent } from './icustomer/icustomer-booth-change/icustomer-booth-change.component';
import { AgentCodeFilterPipe } from './agent/agent-table/agent-code-filter.pipe';
import { AgentFirstnameFilterPipe } from './agent/agent-table/agent-firstname-filter.pipe';
import { AgentMobileFilterPipe } from './agent/agent-table/agent-mobile-filter.pipe';
import { AgentBoothRegisterComponent } from './agent/agent-booth-register/agent-booth-register.component';
import { SaleGroupDeleteLogComponent } from './agent/sale-group-delete-log/sale-group-delete-log.component';
import { RouteTimeChangeLogComponent } from './route/route-time-change-log/route-time-change-log.component';
import { RouteBusinessChangeLogComponent } from './route/route-business-change-log/route-business-change-log.component';
import { IcustomerBoothChangeLogComponent } from './icustomer/icustomer-booth-change-log/icustomer-booth-change-log.component';
import { BoothCodeFilterPipe } from './agent/agent-table/booth-code-filter.pipe';
import { BoothTypeFilterPipe } from './agent/agent-table/agent-type-filter.pipe';
import { IcustomerCardPreviewComponent } from './icustomer/icustomer-card-preview/icustomer-card-preview.component';
import { GlobalSearchPipe } from './global-search.pipe';
import { MonthlyInstitutionBillComponent } from './report/monthly-institution-bill/monthly-institution-bill.component';
import { OnlinePaymentLogComponent } from './online-payment-log/online-payment-log.component';
import { OnlineEnquiryLogComponent } from './online-enquiry-log/online-enquiry-log.component';
import { AutoEnquiryLogComponent } from './auto-enquiry-log/auto-enquiry-log.component';
import { IcustomerBulkPdfComponent } from './icustomer-bulk-pdf/icustomer-bulk-pdf.component';
import { BoothWiseCustomerOrderComponent } from './booth-wise-customer-order/booth-wise-customer-order.component';
import { ComparisionFiveReportComponent } from './comparision-five-report/comparision-five-report.component';
import { MonthlyBillAbstractComponent } from './monthly-bill-abstract/monthly-bill-abstract.component';
import { IcustomerPersonalDetailsComponent } from './icustomer-personal-details/icustomer-personal-details.component';
import { AgentMobileConfirmationComponent } from './agent-mobile-confirmation/agent-mobile-confirmation.component';
import { InstitionBillAsDbfComponent } from './instition-bill-as-dbf/instition-bill-as-dbf.component';
import { ReportThreeComponent } from './report/report-three/report-three.component';
import { OnlinePaymentReportComponent } from './account/online-payment-report/online-payment-report.component';
import { TransactionLogComponent } from './transaction-log/transaction-log.component';
import { MonthlySuppliedMilkForCardCustomerComponent } from './monthly-supplied-milk-for-card-customer/monthly-supplied-milk-for-card-customer.component';
import { MonthlyMilkAbstractComponent } from './monthly-milk-abstract/monthly-milk-abstract.component';
import { InsenctiveReportComponent } from './report/insenctive-report/insenctive-report.component';
import { TimeMismatchAlertComponent } from './time-mismatch-alert/time-mismatch-alert.component';
import { OnlinePaymentTransactionReportComponent } from './online-payment-transaction-report/online-payment-transaction-report.component';
import { SuperSaleGroupComponent } from './super-sale-group/super-sale-group.component';
import { SuperSaleGroupCounterComponent } from './report/super-sale-group-counter/super-sale-group-counter.component';
import { SuperSaleGroupOnlineComponent } from './report/super-sale-group-online/super-sale-group-online.component';
import { SuperSaleGroupWalletComponent } from './report/super-sale-group-wallet/super-sale-group-wallet.component';
import { DateWiseTrayCountComponent } from './date-wise-tray-count/date-wise-tray-count.component';
import { SuperSaleGroupProductComponent } from './report/super-sale-group-product/super-sale-group-product.component';
import { MonthlyCounterSaleComponent } from './monthly-counter-sale/monthly-counter-sale.component';
import { CounterEmployeeSaleForDateComponent } from './counter-employee-sale-for-date/counter-employee-sale-for-date.component';
import { DailyCashCollectionComponent } from './report/daily-cash-collection/daily-cash-collection.component';
import { BoothWiseAgentDetailsComponent } from './booth-wise-agent-details/booth-wise-agent-details.component';
import { CounterWiseAgentDeliveryPerDateComponent } from './counter-wise-agent-delivery-per-date/counter-wise-agent-delivery-per-date.component';
import { CardCustomerDetailsComponent } from './card-customer-details/card-customer-details.component';
import { PrepareDailyScriptComponent } from './prepare-daily-script/prepare-daily-script.component';
import { EmployeeOrderComponent } from './employee-order/employee-order.component';
import { EmployeeOrderEditComponent } from './employee-order-edit/employee-order-edit.component';
import { NewEmployeeOrderComponent } from './new-employee-order/new-employee-order.component';
import { InstutionBillExcelComponent } from './instution-bill-excel/instution-bill-excel.component';
import { InputStockEntryComponent } from './by_products/input-stock-entry/input-stock-entry.component';
import { InputStockEntryWithGrnComponent } from './by_products/input-stock-entry-with-grn/input-stock-entry-with-grn.component';
import { ByProductListComponent } from './by_products/by-product-list/by-product-list.component';
import { ByProductPriceListComponent } from './by_products/by-product-price-list/by-product-price-list.component';
import { ByProductGatepassComponent } from './by_products/by-product-gatepass/by-product-gatepass.component';
import { ByProductGatepassHistoryComponent } from './by_products/by-product-gatepass-history/by-product-gatepass-history.component';
import { ByProductOrderComponent } from './by_products/by-product-order/by-product-order.component';
import { ByProductOrderConfirmComponent } from './by_products/by-product-order-confirm/by-product-order-confirm.component';
import { CounterWiseSaleSummaryByproductsComponent } from './counter-wise-sale-summary-byproducts/counter-wise-sale-summary-byproducts.component';
import { CounterSaleForByproductsComponent } from './counter-sale-for-byproducts/counter-sale-for-byproducts.component';
import { OnlinePaymentLogExcelComponent } from './online-payment-log-excel/online-payment-log-excel.component';
import { EmployeeOrderExcelComponent } from './employee-order-excel/employee-order-excel.component';
import { ByProductReturnGatepassComponent } from './by_products/by-product-return-gatepass/by-product-return-gatepass.component';
import { ByProductGatepassBillingPreviewComponent } from './by_products/by-product-gatepass-billing-preview/by-product-gatepass-billing-preview.component';
import { BankTransactionExcelFileUploadComponent } from './bank-transaction-excel-file-upload/bank-transaction-excel-file-upload.component';
import { CombainReportForOnlineComponent } from './combain-report-for-online/combain-report-for-online.component';
import { CityAndRouteWiseSaleExcelComponent } from './city-and-route-wise-sale-excel/city-and-route-wise-sale-excel.component';
import { CustomerOrderDeleteLogComponent } from './customer-order-delete-log/customer-order-delete-log.component';
import { BankTransactionExcel1Component } from './bank-transaction-excel1/bank-transaction-excel1.component';
import { BankTransactionExcel2Component } from './bank-transaction-excel2/bank-transaction-excel2.component';
import { BankTransactionExcel3Component } from './bank-transaction-excel3/bank-transaction-excel3.component';
import { EmployeeOrderForCurrentMonthComponent } from './employee-order-for-current-month/employee-order-for-current-month.component';
import { BillAlertComponent } from './report/bill-alert/bill-alert.component';
import { BankTransactionExcel4Component } from './bank-transaction-excel4/bank-transaction-excel4.component';
import { BusinessWiseSaleAndTransactionComponent } from './report/business-wise-sale-and-transaction/business-wise-sale-and-transaction.component';
import { BusinessTypeWiseProductPriceComponent } from './by_products/business-type-wise-product-price/business-type-wise-product-price.component';
import { ValidateRouteValueMismatchComponent } from './report/validate-route-value-mismatch/validate-route-value-mismatch.component';
import { NewPurchaseCompanyComponent } from './by_products/new-purchase-company/new-purchase-company.component';
import { DailySaleUpdateComponent } from './by_products/daily-sale-update/daily-sale-update.component';
import { ByProductMonthlysaleComponent } from './by-product-monthlysale/by-product-monthlysale.component';
import { MonthlySaleOverallComponent } from './by_products/monthly-sale-overall/monthly-sale-overall.component';
import { MonthlySaleAbstractComponent } from './by_products/monthly-sale-abstract/monthly-sale-abstract.component';
import { DailySaleProductWiseComponent } from './by_products/daily-sale-product-wise/daily-sale-product-wise.component';
import { CashReceiptPreviewComponent } from './by_products/cash-receipt-preview/cash-receipt-preview.component';
import { CashReceiptDownloadComponent } from './by_products/cash-receipt-download/cash-receipt-download.component';
import { VehicleGatePassComponent } from './by_products/vehicle-gate-pass/vehicle-gate-pass.component';
import { DailyStockReportComponent } from './by_products/daily-stock-report/daily-stock-report.component';
import { ReopenSaleComponent } from './by_products/reopen-sale/reopen-sale.component';
import { DailySaleComponent } from './by_products/daily-sale/daily-sale.component';
import { DailySaleCashCreditStatementComponent } from './by_products/daily-sale-cash-credit-statement/daily-sale-cash-credit-statement.component';
import { DailySaleUploadComponent } from './by_products/daily-sale-upload/daily-sale-upload.component';
import { SalesTaxAbstractComponent } from './sales-tax-abstract/sales-tax-abstract.component';
import { GovtJsonComponent } from './by_products/govt-json/govt-json.component';
import { GovtJsonNewComponent } from './by_products/govt-json-new/govt-json-new.component';
import { BillWithGstComponent } from './report/bill-with-gst/bill-with-gst.component';
import { FermentedGstBillComponent } from './report/fermented-gst-bill/fermented-gst-bill.component';
import { FermentedGovtJsonComponent } from './report/fermented-govt-json/fermented-govt-json.component';
import { AnalyticsComponent } from './by_products/analytics/analytics.component';
import { BusinessGroupComponent } from './agent/business-group/business-group.component';
import { ZoneWiseReportGstComponent } from './by_products/zone_wise_report/zone-wise-report-gst/zone-wise-report-gst.component';
import { FreeMilkComponent } from './icustomer/free-milk/free-milk.component';
import { BillNumberWiseReportComponent } from './report/reliance/bill-number-wise-report/bill-number-wise-report.component';
import { DailyStackReportNewComponent } from './daily-stack-report-new/daily-stack-report-new.component';
import { ByProductListAddComponent } from './by_products/by-product-list-add/by-product-list-add.component';
import { BusinesswiseCreditAmountComponent } from './businesswise-credit-amount/businesswise-credit-amount.component';
import { Comp2aReportComponent } from './comp2a-report/comp2a-report.component';
import { TransactiondetailReportComponent } from './transactiondetail-report/transactiondetail-report.component';
import { BusinessdetailReportComponent } from './businessdetail-report/businessdetail-report.component';
import { BusinessabstractdetailsComponent } from './businessabstractdetails/businessabstractdetails.component';
import { CustomertransacationdetailsreportComponent } from './customertransacationdetailsreport/customertransacationdetailsreport.component';
import { CustomerabstracetdetailsreportComponent } from './customerabstracetdetailsreport/customerabstracetdetailsreport.component';
import { CustomerwisedetailsreportComponent } from './customerwisedetailsreport/customerwisedetailsreport.component';
import { BankTransactionExcel2AComponentComponent } from './bank-transaction-excel2-acomponent/bank-transaction-excel2-acomponent.component';

@NgModule({
  declarations: [
    AppComponent,
    LeftMenuComponent,
    LoginComponent,
    ShellComponent,
    PageNotFoundComponent,
    AgentRegisterComponent,
    ZoneRegisterComponent,
    MasterOverviewComponent,
    BoothTypeRegisterComponent,
    ConstituencyRegisterComponent,
    WardRegisterComponent,
    ZoneTableComponent,
    BoothTypeTableComponent,
    WardTableComponent,
    ConstituencyTableComponent,
    AgentTableComponent,
    ProductGroupTableComponent,
    ProductRegisterComponent,
    ProductGroupRegisterComponent,
    VehicleTransportTableComponent,
    ProductTableComponent,
    ProductUnitTableComponent,
    ProductUnitRegisterComponent,
    BoothTableComponent,
    BoothRegisterComponent,
    MaserPageHeaderComponent,
    VehicleTransportRegisterComponent,
    RelationTypeRegisterComponent,
    RelationTypeTableComponent,
    TalukTableComponent,
    TalukRegisterComponent,
    EmployeeTableComponent,
    EmployeeRegisterComponent,
    UnionOfficeRegisterComponent,
    UnionOfficeTableComponent,
    LocationCategoryTableComponent,
    LocationCategoryRegisterComponent,
    IcustomerTableComponent,
    IcustomerRegisterComponent,
    VehicleTypeTableComponent,
    VehicleTypeRegisterComponent,
    VehicleRegisterComponent,
    VehicleTableComponent,
    RouteTableComponent,
    RouteRegisterComponent,
    ProductPriceEditShellComponent,
    BusinessTypeWiseComponent,
    BusinessTypeWiseProductCommissionEditComponent,
    DiscountProductPriceEditComponent,
    BusinessWiseDiscountPriceEditDiaglogComponent,
    BusinessTypeWiseProductDiscountComponent,
    BusinessTypeWiseProductDiscountEditDialogComponent,
    RouteBusinessMapComponent,
    AgentOrderComponent,
    IcustomerTypeWiseDiscountProductPriceComponent,
    IcustomerTypeWiseDiscountProductPriceEditDialogBoxComponent,
    ProductTraceComponent,
    BusinessTypeWiseProductCommissionTraceLogComponent,
    BusinessTypeWiseProductDiscountTraceLogComponent,
    BusinessWiseProductDiscountTraceLogComponent,
    IcustomerTypeWiseProductDiscountTraceLogComponent,
    BoothRegisterPopupComponent,
    AgentOrderPipe,
    ProductPricePipe,
    IndentDashboardComponent,
    RouteIndentDetailsComponent,
    ProductSessionAvailableEditComponent,
    TimeExpirePipe,
    IcustomerOrderRegisterComponent,
    IcustomerOrderHistoryComponent,
    DashboardComponent,
    ProductMasterComponent,
    AgentOrderHistoryComponent,
    RouteVehicleMapTableComponent,
    BusinessWiseBillComponent,
    RouteGatepassComponent,
    RouteWiseBillComponent,
    AlertComponent,
    SidemenuComponent,
    AgentMonthlyReportComponent,
    CorporationZoneTableComponent,
    CorporationZoneRegisterComponent,
    AgentImagePopupComponent,
    DistrictTableComponent,
    DistrictRegisterComponent,
    AgentConfirmOrderComponent,
    BlockTableComponent,
    BlockRegisterComponent,
    IcustomerConfirmOrderComponent,
    IcustomerLimitErrorComponent,
    AddToWalletComponent,
    BoothChangeForOrderComponent,
    IndivioulBoothSelectionComponent,
    ChequeApprovalComponent,
    ChequeClearPopupComponent,
    AgentTransactionComponent,
    IcustomerTransactionComponent,
    AgentOrderEditComponent,
    RouteTraceAdjustComponent,
    NotClosedRouteListComponent,
    ZoneWiseCountComponent,
    CounterReportPerDayComponent,
    OldIndentComponent,
    TotalSalePerDayComponent,
    TotalSalePerMonthComponent,
    RouteWiseSaleAbstraceComponent,
    UniqueRouteWiseReportComponent,
    RouteVehicleEditComponent,
    MilkAcknowlegdementReportPerSessionComponent,
    AllZoneReportPerSessionComponent,
    DailySaleZoneWiseComponent,
    TempComponent,
    RouteWiseSaleStatementComponent,
    ZoneWiseAbstractComponent,
    BusinessTypeWiseSummaryComponent,
    PdfPreviewComponent,
    UnionWiseSummaryComponent,
    ZoneWiseRouteAbstractComponent,
    AgentMonthlyCommissionComponent,
    DiffrentTypeOfReportComponent,
    RouteTimeChangeComponent,
    FinanceReportComponent,
    TotalMilkSaleComponent,
    InstitionBillComponent,
    TrayCountComponent,
    LeakageAllowanceComponent,
    SimpleComparisionReportComponent,
    AdvanacedComparisonReportComponent,
    GeneralReportForRouteComponent,
    IcustomerBoothChangeComponent,
    AgentCodeFilterPipe,
    AgentFirstnameFilterPipe,
    AgentMobileFilterPipe,
    BoothCodeFilterPipe,
    AgentZoneFilterPipe,
    AgentBoothRegisterComponent,
    SaleGroupDeleteLogComponent,
    RouteTimeChangeLogComponent,
    RouteBusinessChangeLogComponent,
    IcustomerBoothChangeLogComponent,
    BoothTypeFilterPipe,
    IcustomerCardPreviewComponent,
    GlobalSearchPipe,
    MonthlyInstitutionBillComponent,
    OnlinePaymentLogComponent,
    OnlineEnquiryLogComponent,
    AutoEnquiryLogComponent,
    IcustomerBulkPdfComponent,
    BoothWiseCustomerOrderComponent,
    ComparisionFiveReportComponent,
    MonthlyBillAbstractComponent,
    IcustomerPersonalDetailsComponent,
    AgentMobileConfirmationComponent,
    InstitionBillAsDbfComponent,
    ReportThreeComponent,
    OnlinePaymentReportComponent,
    TransactionLogComponent,
    MonthlyMilkAbstractComponent,
    MonthlySuppliedMilkForCardCustomerComponent,
    InsenctiveReportComponent,
    TimeMismatchAlertComponent,
    OnlinePaymentTransactionReportComponent,
    SuperSaleGroupComponent,
    SuperSaleGroupCounterComponent,
    SuperSaleGroupOnlineComponent,
    SuperSaleGroupWalletComponent,
    DateWiseTrayCountComponent,
    SuperSaleGroupProductComponent,
    MonthlyCounterSaleComponent,
    CounterEmployeeSaleForDateComponent,
    DailyCashCollectionComponent,
    BoothWiseAgentDetailsComponent,
    CounterWiseAgentDeliveryPerDateComponent,
    CardCustomerDetailsComponent,
    PrepareDailyScriptComponent,
    EmployeeOrderComponent,
    EmployeeOrderEditComponent,
    NewEmployeeOrderComponent,
    InstutionBillExcelComponent,
    InputStockEntryComponent,
    InputStockEntryWithGrnComponent,
    ByProductListComponent,
    ByProductPriceListComponent,
    ByProductGatepassComponent,
    ByProductGatepassHistoryComponent,
    ByProductOrderComponent,
    ByProductOrderConfirmComponent,
    CounterWiseSaleSummaryByproductsComponent,
    CounterSaleForByproductsComponent,
    OnlinePaymentLogExcelComponent,
    EmployeeOrderExcelComponent,
    ByProductReturnGatepassComponent,
    ByProductGatepassBillingPreviewComponent,
    BankTransactionExcelFileUploadComponent,
    CombainReportForOnlineComponent,
    CityAndRouteWiseSaleExcelComponent,
    CustomerOrderDeleteLogComponent,
    BankTransactionExcel1Component,
    BankTransactionExcel2Component,
    BankTransactionExcel3Component,
    EmployeeOrderForCurrentMonthComponent,
    BillAlertComponent,
    BankTransactionExcel4Component,
    BusinessWiseSaleAndTransactionComponent,
    BusinessTypeWiseProductPriceComponent,
    ValidateRouteValueMismatchComponent,
    NewPurchaseCompanyComponent,
    DailySaleUpdateComponent,
    ByProductMonthlysaleComponent,
    MonthlySaleOverallComponent,
    MonthlySaleAbstractComponent,
    DailySaleProductWiseComponent,
    CashReceiptPreviewComponent,
    CashReceiptDownloadComponent,
    VehicleGatePassComponent,
    DailyStockReportComponent,
    ReopenSaleComponent,
    DailySaleComponent,
    DailySaleCashCreditStatementComponent,
    DailySaleUploadComponent,
    SalesTaxAbstractComponent,
    GovtJsonComponent,
    GovtJsonNewComponent,
    BillWithGstComponent,
    FermentedGstBillComponent,
    FermentedGovtJsonComponent,
    AnalyticsComponent,
    BusinessGroupComponent,
    ZoneWiseReportGstComponent,
    FreeMilkComponent,
    BillNumberWiseReportComponent,
    DailyStackReportNewComponent,
    ByProductListAddComponent,
    BusinesswiseCreditAmountComponent,
    Comp2aReportComponent,
    TransactiondetailReportComponent,
    BusinessdetailReportComponent,
    BusinessabstractdetailsComponent,
    CustomertransacationdetailsreportComponent,
    CustomerabstracetdetailsreportComponent,
    CustomerwisedetailsreportComponent,
    BankTransactionExcel2AComponentComponent
  ],
  imports: [
    MatStepperModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSnackBarModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatDialogModule,
    DragDropModule,
    MatDividerModule,
    MatRadioModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    PipesModule,
    MatAutocompleteModule,
    AmazingTimePickerModule,
    MatTabsModule,
    MatChipsModule,
    MatButtonToggleModule,
    MatTableModule,
    MatProgressBarModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBAG_QnJjbKczCVI093hYwMDS14b8DGEcI'
    }),
  ],

  providers: [MatDatepickerModule],
  bootstrap: [AppComponent],
  entryComponents: [
    ByProductListAddComponent,
    BusinessTypeWiseProductCommissionEditComponent,
    BusinessWiseDiscountPriceEditDiaglogComponent,
    BusinessTypeWiseProductDiscountEditDialogComponent,
    IcustomerTypeWiseDiscountProductPriceEditDialogBoxComponent,
    BoothRegisterPopupComponent,
    RouteIndentDetailsComponent,
    AgentImagePopupComponent,
    AgentConfirmOrderComponent,
    IcustomerLimitErrorComponent,
    BoothChangeForOrderComponent,
    IndivioulBoothSelectionComponent,
    ChequeClearPopupComponent,
    AgentOrderEditComponent,
    RouteTraceAdjustComponent,
    NotClosedRouteListComponent,
    ZoneWiseCountComponent,
    RouteVehicleEditComponent,
    PdfPreviewComponent,
    IcustomerCardPreviewComponent,
    OnlineEnquiryLogComponent,
    IcustomerPersonalDetailsComponent,
    AgentMobileConfirmationComponent,
    TimeMismatchAlertComponent,
    SuperSaleGroupCounterComponent,
    SuperSaleGroupOnlineComponent,
    SuperSaleGroupWalletComponent,
    SuperSaleGroupProductComponent,
    EmployeeOrderEditComponent,
    ByProductOrderConfirmComponent,
    ByProductGatepassBillingPreviewComponent,
    BillAlertComponent,
    IcustomerConfirmOrderComponent,
    NewPurchaseCompanyComponent,
    BusinessTypeWiseProductPriceComponent,
    CashReceiptPreviewComponent
  ]
})
export class AppModule { }
